<template>
  <div class="text-center" v-if="loading">
    <span>Loading</span><br>
    <CSpinner grow=true color="danger"></CSpinner>
  </div>
  <CCard v-else>
    <CCardBody>
      <form @submit="onSubmit" enctype="multipart/form-data">
        <form-wizard color="#5C13BA" subtitle="" title="Edit Tournament">
          <tab-content icon="ti-settings" title="TOURNAMENT INFO">
            <CRow>
              <CCol sm="12">
                <CInput label="Name" placeholder="Enter tournament title" v-model="tournament.name" />
              </CCol>
            </CRow>
<!--            <CRow>-->
<!--              <CCol sm="12">-->
<!--                <CSelect label="Partner (optional)" :options="partners" :value.sync="tournament.partner_id" />-->
<!--              </CCol>-->
<!--            </CRow>-->
            <CRow>
              <CCol sm="12">
                <CInput label="Pass Code (optional)" placeholder="Enter a pass code for tournament entry" v-model="tournament.passcode" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="Description" placeholder="Enter tournament description" v-model="tournament.description" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea label="Terms and Conditions" placeholder="Enter Terms & Condition" v-model="tournament.tc"
                           rows="10" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <img :src="img_url" style="width: 200px; height: 200px;" />
                <CInputFile
                    label="Banner Thumbnail"
                    vertical
                    ref="file"
                    type="file"
                    @change="onUploadImage"
                />
              </CCol>
            </CRow>
            <CRow>
              <!--            <CCol sm="12">-->
              <!--               <CSelect label="Registration Currency" :options="currency_options" :value.sync="tournament.currency" />-->
              <!--            </CCol>-->
            </CRow>
            <CRow>
              <CCol sm="12" v-if="tournament.currency==='money' || tournament.currency==='optional'">
                <CInput label="Registration Fee" type="number" placeholder="Registration Fee (BDT)" v-model="tournament.fee" />
              </CCol>
              <CCol sm="12" v-if="tournament.currency==='coin' || tournament.currency==='optional'">
                <CInput label="Coin Fee" type="number" placeholder="Registration Fee (Coins)" v-model="tournament.coin_fee" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="No. of Prizes" type="number" placeholder="Enter No. of Prizes" v-model="tournament.prize_count" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="No. of Chances" type="number" placeholder="Enter No. of Chances" v-model="tournament.chances" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CSelect label="Payment Frequency" :options="payment_frequency" :value.sync="tournament.payment_once" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CInput label="Prize" placeholder="Enter First prize" v-model="tournament.prize" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <label>Tournament Duration</label>
                <VueCtkDateTimePicker label="Start Time" color="#FF2E75" v-model="tournament.start_time" />
              </CCol>
            </CRow><CRow>
            <CCol sm="12">
              <VueCtkDateTimePicker label="End Time"  color="#FF2E75" v-model="tournament.end_time" />
            </CCol>
          </CRow>
            <CRow>
              <CCol sm="12">
                <input class="m-3" type="checkbox" v-model="tournament.status" />Publish
              </CCol>
            </CRow>
          </tab-content>
                    <tab-content icon="ti-settings" title="Prize Pool">
                      <CRow v-for="(prize,index) in tournament.prize_pool" :key="index">
                        <CCol sm="4">
                          <CInput label="Rank Start" type="number" placeholder="Start from" v-model="prize.rank_start" />
                        </CCol>
                        <CCol sm="4">
                          <CInput label="Rank End" type="number" placeholder="To End" v-model="prize.rank_end" />
                        </CCol>
                        <CCol sm="3">
                          <CInput label="Prize" type="text" placeholder="Prize" v-model="prize.prize" />
                        </CCol>
                        <CCol sm="1">
                          <button class="btn-danger" @click.prevent="remove_prize(index)"><CIcon name="cil-trash"/></button>
                        </CCol>
                      </CRow>

                      <CRow style="justify-content: center;">
                        <button class="btn btn-lg btn-danger" @click.prevent="add_prize">Add Prize Pool</button>
                      </CRow>
                    </tab-content>
          <button class="btn btn-lg btn-success" slot="finish" type="submit">Update Tournament</button>
        </form-wizard>
      </form>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "TournamentEdit",
  data() {
    return {
      tournament: {},
      partners: [{ value: null, label: 'Select a Partner'}],
      img_url: '',
      currency_options: [{value:'money',label:'money'},{value:'coin',label:'coin'},{value:'optional',label:'optional'}],
      payment_frequency: [{value:1,label:'Once'},{value:0, label:'For Every Game'}],
      prize_pool_changed:false,
      loading: false,
    };
  },
  created() {
    this.getTournament();
    // this.getPartners();
  },
  // mounted(){
  //   // this.$nextTick(function () {
  //     // Code that will run only after the
  //     // entire view has been rendered
  //     this.prize_pool_changed = false;
  //   // })
  // },
  methods: {
    add_prize(){
      this.tournament.prize_pool.push({start:0,end:0,prize:0})
    },
    remove_prize(index){
      if(this.tournament.prize_pool.length>3) {
        this.tournament.prize_pool.splice(index, 1)
      }else{
        this.$swal("Error", "Minimum Prize Pool must have 3 prizes", "error");
      }
    },
    async getTournament() {
      await this.$axios
          .get(`${ADMIN_URL}/tournament`,{
            params: {
              tournament_id : this.$route.params.id
            }
          })
          .then((response) => {
            console.log(response.data);
            this.tournament = response.data;
            this.img_url = ROOT_URL + "/" + this.tournament.image;
            // console.log('value made false2')
            // this.prize_pool_changed = false;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
      console.log('value made false')
      this.prize_pool_changed = false;
    },
    getPartners() {
      this.$axios
          .get(`${ADMIN_URL}/partners`)
          .then((response) => {
            console.log(response.data);
            response.data.forEach((e) => {
              this.partners.push({
                value: e.id,
                label: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onUploadImage(e) {
      this.tournament.image = e[0];
      this.img_url = URL.createObjectURL(e[0]);
    },
    onUploadFile(e,f) {
      this.import_file = e[0];
    },
    onSubmit(e) {
      e.preventDefault();
      this.loading = true
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("id", this.tournament.id);
      formData.append("name", this.tournament.name);
      formData.append("description", this.tournament.description);
      formData.append("image", this.tournament.image);
      formData.append("fee", this.tournament.fee);
      // formData.append("question_count", this.tournament.question_count);
      formData.append("prize_count", this.tournament.prize_count);
      formData.append("prize", this.tournament.prize);
      formData.append("tc", this.tournament.tc);
      // formData.append("duration", this.tournament.duration);
      formData.append("chances", this.tournament.chances);
      formData.append("start_time", this.tournament.start_time);
      formData.append("end_time", this.tournament.end_time);
      formData.append("status", this.tournament.status);
      // formData.append("currency", this.tournament.currency);
      formData.append("payment_once", this.tournament.payment_once);
      formData.append("prize_pool_changed", this.prize_pool_changed);
      formData.append("prize_pools", JSON.stringify(this.tournament.prize_pool));
      if(this.tournament.partner_id)
        formData.append("partner_id", this.tournament.partner_id);


      if(this.tournament.passcode)
      {
        formData.append("passcode", this.tournament.passcode);
      }
      if(this.tournament.coin_fee)
      {
        formData.append("coin_fee", this.tournament.coin_fee);
      }

      this.$axios
          .post(`${ADMIN_URL}/tournaments/update`,formData,config)
          .then((response) => {
            console.log("Success", response);
            this.loading = false
            if(response.data.success)
            {
              this.$swal("Success", response.data.message, "success");
              this.$router.replace("/tournaments")
            }
            else
            {
              this.$swal("Error",response.data.message, "error");
            }
          })
          .catch((error) => {
            console.log("Error  ... ", error);
            currentObj.output = error;
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
  watch: {
    // whenever question changes, this function will run
    'tournament.prize_pool': {
      handler() {
          this.prize_pool_changed = true;
      },
      deep: true
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>
